<template>
	<div class="departments">
		<FunctionTitle :title="main_title" />
		<CommonFlame :title="sub_title">
			<v-sheet elevation="0">
				<div class="table-container mt-4">
					<v-data-table
						locale="ja-JP"
						:headers="headers"
						:items="prefixes"
						:mobile-breakpoint="240"
						hide-default-footer
						disable-filtering
						disable-pagination
						disable-sort
						no-data-text="データがありません。"
					>
						<template v-slot:item="{ item }">
							<tr>
								<td
									@click="
										$router.push({
											name: 'process_by_classification_ganttchart',
											params: { id: item.id },
										})
									"
								>
									{{ item.name }}
								</td>
							</tr>
						</template>
					</v-data-table>
				</div>
			</v-sheet>
		</CommonFlame>
	</div>
</template>

<script>
import errorHandling from "../../helper/errorHandling"
import axios from "axios"
import authenticate from "../../helper/authenticate"
import CommonFlame from "../shared/CommonFlame.vue"
import FunctionTitle from "../shared/FunctionTitle.vue"

export default {
	components: {
		FunctionTitle,
		CommonFlame,
	},
	data() {
		return {
			main_title: "工程予定表",
			sub_title: "各品目リンク",
			headers: [{ text: "品目名", value: "name", width: "280px" }],
			prefixes: [],
		}
	},

	mounted() {
		authenticate.authenticateUser()
		this.fetchPrefixes()
	},

	methods: {
		fetchPrefixes() {
			const headers = authenticate.setHeader()
			axios
				.get("/erp/v1/prefixes", { headers })
				.then((res) => {
					this.prefixes = res.data.prefixes
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
	},
}
</script>
